import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Container,
  Segment,
  Table,
  Grid,
  Header,
  Icon,
  Button,
  Input,
  Message,
  Tab,
  Label,
  Menu,
  Popup,
  Loader
} from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

import find from 'lodash/find'
import groupBy from 'lodash/groupBy'
import orderBy from 'lodash/orderBy'
import constantCase from 'constant-case'

import './Attendances.css'
import AttendancesApproval from './AttendancesApproval'

const _ = { find, groupBy, orderBy }

const changeCase = {
  constantCase: constantCase
}

const AttendancesPV = (props) => {
  if (props.auth) {
    const {
      column, direction, section, error, success, username, quarter, dirtyInput,
      sectionStudents, daysOfSchool, areAttendancesSaved, userType, userId
    } = props;

    if(section.length !== 1) return <Loader active inline='centered' />;

    const sectionDetail = _.find(section[0].details, {
      type: 'attendance',
      quarter: parseInt(quarter)
    });

    let isDisabled = true;

    if(sectionDetail.status === 'To Do' || sectionDetail.status === 'Discarded') {
      if(userType === 'admin' || section[0].teacherId === userId) {
        isDisabled = false;
      }
    } else if(sectionDetail.status === 'Created') {
      if(userType === 'admin' || userType === 'levelHead') {
        isDisabled = false;
      }
    } else {
      if(userType === 'admin' || userType === 'principal' || userType === 'registrar') {
        isDisabled = false;
      }
    }

    const gender = _.groupBy(sectionStudents, o => o.student.gender)
    let currentDataMale = [], currentDataFemale = [];
    if(gender.hasOwnProperty('Male')) {
      currentDataMale = gender['Male'];
    }

    if(gender.hasOwnProperty('Female')) {
      currentDataFemale = gender['Female'];
    }

    const studentsTableMale = currentDataMale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      if (props[`${changeCase.constantCase(studentName)}-JUN`] === undefined){
        return null;
      } else {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell>{studentName}</Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JUL`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JUL`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JUL`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-AUG`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-AUG`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-AUG`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-SEP`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-SEP`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-SEP`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-OCT`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-OCT`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-OCT`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-NOV`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-NOV`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-NOV`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-DEC`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-DEC`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-DEC`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JAN`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JAN`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JAN`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-FEB`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-FEB`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-FEB`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-MAR`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-MAR`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-MAR`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-APR`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-APR`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-APR`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-MAY`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-MAY`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-MAY`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JUN`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JUN`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JUN`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              <span> {props[`${changeCase.constantCase(studentName)}-TOTAL`]} </span>
            </Table.Cell>
          </Table.Row>
        );
      }
    });

    const studentsTableMaleTardy = currentDataMale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      if (props[`${changeCase.constantCase(studentName)}-JUN`] === undefined){
        return null;
      } else {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell>{studentName}</Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JULTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JULTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JULTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-AUGTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-AUGTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-AUGTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-SEPTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-SEPTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-SEPTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-OCTTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-OCTTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-OCTTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-NOVTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-NOVTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-NOVTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-DECTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-DECTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-DECTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JANTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JANTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JANTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-FEBTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-FEBTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-FEBTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-MARTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-MARTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-MARTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-APRTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-APRTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-APRTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-MAYTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-MAYTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-MAYTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JUNTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JUNTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JUNTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              <span> {props[`${changeCase.constantCase(studentName)}-TOTALTardy`]} </span>
            </Table.Cell>
          </Table.Row>
        );
      }
    });

    const studentsTableFemale = currentDataFemale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+ sectionStudent.student.firstName;
      if (props[`${changeCase.constantCase(studentName)}-JUN`] === undefined){
        return null;
      } else {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell>{studentName}</Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JUL`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JUL`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JUL`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-AUG`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-AUG`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-AUG`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-SEP`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-SEP`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-SEP`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-OCT`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-OCT`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-OCT`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-NOV`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-NOV`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-NOV`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-DEC`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-DEC`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-DEC`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JAN`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JAN`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JAN`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-FEB`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-FEB`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-FEB`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-MAR`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-MAR`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-MAR`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-APR`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-APR`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-APR`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-MAY`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-MAY`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-MAY`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JUN`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JUN`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JUN`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              <span> {props[`${changeCase.constantCase(studentName)}-TOTAL`]} </span>
            </Table.Cell>
          </Table.Row>
        );
      }
    });

    const studentsTableFemaleTardy = currentDataFemale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+ sectionStudent.student.firstName;
      if (props[`${changeCase.constantCase(studentName)}-JUN`] === undefined){
        return null;
      } else {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell>{studentName}</Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JULTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JULTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JULTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-AUGTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-AUGTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-AUGTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-SEPTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-SEPTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-SEPTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-OCTTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-OCTTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-OCTTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-NOVTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-NOVTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-NOVTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-DECTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-DECTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-DECTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JANTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JANTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JANTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-FEBTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-FEBTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-FEBTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-MARTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-MARTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-MARTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-APRTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-APRTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-APRTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-MAYTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-MAYTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-MAYTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-JUNTardy`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-JUNTardy`}
                  size='small'
                  className='attendances-input'
                  value={props[`${changeCase.constantCase(studentName)}-JUNTardy`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              <span> {props[`${changeCase.constantCase(studentName)}-TOTALTardy`]} </span>
            </Table.Cell>
          </Table.Row>
        );
      }
    });

    const headers = (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell
            textAlign='center'
            sorted={column === 'name' ? direction : null}
            onClick={() => props.handleSort('name')}
          >
            Name
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>JUL</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>AUG</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>SEP</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>OCT</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>NOV</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>DEC</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>JAN</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>FEB</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>MAR</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>APR</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>MAY</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>JUN</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>TOTAL</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    )

    const panes = [
      { menuItem: 'Days Present', render: () =>
        <Tab.Pane>
          <Container>
            <Grid>
              <Grid.Row>
                <Grid.Column width={16}>
                  <h4>Male</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableMale}</Table.Body>

                  </Table>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <h4>Female</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableFemale}</Table.Body>

                  </Table>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Tab.Pane>
      },
      { menuItem: 'Tardiness', render: () =>
        <Tab.Pane>
          <Container>
            <Grid>
              <Grid.Row>
                <Grid.Column width={16}>
                  <h4>Male</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableMaleTardy}</Table.Body>

                  </Table>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <h4>Female</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableFemaleTardy}</Table.Body>

                  </Table>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Tab.Pane>
      }
    ]
    const sortedCreated = _.orderBy(props.created, ['createdDate'], ['asc']);
    const createdTableBody = sortedCreated.map((create, key )=> {
      const section = _.find(props.sections, {
        sectionId: create.section.sectionId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/attendances/${props.schoolYearId}/${create.section.sectionId}?quarter=${quarter}`}>
              {section.gradeLevel} - {section.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });
    const sortedChecked = _.orderBy(props.checked, ['checkedDate'], ['asc']);
    const checkedTableBody = sortedChecked.map((check, key )=> {
      const section = _.find(props.sections, {
        sectionId: check.section.sectionId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/attendances/${props.schoolYearId}/${check.section.sectionId}?quarter=${quarter}`}>
              {section.gradeLevel} - {section.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });
    const sortedReviewed = _.orderBy(props.reviewed, ['createdDate'], ['asc']);
    const reviewedTableBody = sortedReviewed.map((review, key )=> {
      const section = _.find(props.sections, {
        sectionId: review.section.sectionId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/attendances/${props.schoolYearId}/${review.section.sectionId}?quarter=${quarter}`}>
              {section.gradeLevel} - {section.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });

    return (
      <div>
        <Segment>
          {
            sectionStudents.length === 0 ?
            <Segment placeholder>
              <Header icon>
                <Icon name='database' />
                Populate the {section[0].gradeLevel} - {section[0].name} with students.
              </Header>
              <Button primary>Section Page</Button>
            </Segment> :
            <Grid>
              <Grid.Row className="attendance-title-row" columns={3}>
                <Grid.Column width={8}>
                  <span className="attendance-title">
                    {section[0].gradeLevel} - {section[0].name}
                  </span>
                </Grid.Column>
                <Grid.Column width={3}>
                </Grid.Column>
                <Grid.Column width={5} textAlign='right'>

                {
                  sectionDetail.status === 'Approved' ?
                  <Label color='green' horizontal>
                    {sectionDetail.status}
                  </Label> :
                  <Label color='yellow' horizontal>
                    {sectionDetail.status}
                  </Label>
                }
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Menu compact>
                      {
                        userType === 'admin' ||  userType === 'levelHead'?
                        <Popup
                          on='click'
                          position='bottom center'
                          trigger={
                            <Menu.Item as='a'>
                              <Icon name='check' /> For Checking
                              <Label color={props.created.length === 0 ? 'green' : 'red'} floating>
                                {props.created.length}
                              </Label>
                            </Menu.Item>
                          }
                          className={props.created.length === 0 ? '' : 'popup-reminders'}
                        >
                        <Table basic='very' size='small'>
                          <Table.Body>
                            {createdTableBody}
                          </Table.Body>
                        </Table>
                        </Popup>: null
                      }
                      {
                        userType === 'admin' ||  userType === 'registrar'?
                        <Popup
                          on='click'
                          position='bottom center'
                          trigger={
                            <Menu.Item as='a'>
                              <Icon name='book' /> For Review
                              <Label color={props.checked.length === 0 ? 'green' : 'red'} floating>
                                {props.checked.length}
                              </Label>
                            </Menu.Item>
                          }
                          className={props.checked.length === 0 ? '' : 'popup-reminders'}
                        >
                        <Table basic='very' size='small'>
                          <Table.Body>
                            {checkedTableBody}
                          </Table.Body>
                        </Table>
                        </Popup>: null
                      }
                      {
                        userType === 'admin' ||  userType === 'principal'?
                        <Popup
                          on='click'
                          position='bottom center'
                          trigger={
                            <Menu.Item as='a'>
                              <Icon name='thumbs up' /> For Approval
                              <Label color={props.reviewed.length === 0 ? 'green' : 'red'} floating>
                                {props.reviewed.length}
                              </Label>
                            </Menu.Item>
                          }
                          className={props.reviewed.length === 0 ? '' : 'popup-reminders'}
                        >
                        <Table basic='very' size='small'>
                          <Table.Body>
                            {reviewedTableBody}
                          </Table.Body>
                        </Table>
                        </Popup>: null
                      }
                    </Menu>
                </Grid.Column>
                <Grid.Column width={8} textAlign='right'>
                  {
                    areAttendancesSaved &&
                    <AttendancesApproval
                      username={username}
                      sectionDetail={sectionDetail}
                      userType={userType}
                      open={props.open}
                      handleApprovalOpen={props.handleApprovalOpen}
                      handleApprovalClose={props.handleApprovalClose}
                      handleUpdateSectionDetails={props.handleUpdateSectionDetails}
                    />
                  }
                <Button floated='right' onClick={props.handleSubmit} color='green' icon labelPosition='left'>
                  <Icon name='save' /> Save Attendance Sheet
                </Button>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Table celled compact size='small'>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell textAlign='center'>JUL</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>AUG</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>SEP</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>OCT</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>NOV</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>DEC</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>JAN</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>FEB</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>MAR</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>APR</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>MAY</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>JUN</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>TOTAL</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      <Table.Row>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('JUL')}
                      >
                        {daysOfSchool.julDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('AUG')}
                      >
                        {daysOfSchool.augDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('SEP')}
                      >
                        {daysOfSchool.sepDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('OCT')}
                      >
                        {daysOfSchool.octDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('NOV')}
                      >
                        {daysOfSchool.novDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('DEC')}
                      >
                        {daysOfSchool.decDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('JAN')}
                      >
                        {daysOfSchool.janDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('FEB')}
                      >
                        {daysOfSchool.febDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('MAR')}
                      >
                        {daysOfSchool.marDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('APR')}
                      >
                        {daysOfSchool.aprDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('MAY')}
                      >
                        {daysOfSchool.mayDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('JUN')}
                      >
                        {daysOfSchool.junDays}
                      </Table.Cell>
                      <Table.Cell
                        className='attendance-table-cell-sample'
                        textAlign='center'
                        collapsing onClick={() => props.handleClickTableCell('TOTAL')}
                      >
                        {daysOfSchool.totalDays}
                      </Table.Cell>
                      </Table.Row>
                    </Table.Body>

                  </Table>

                </Grid.Column>

                <Grid.Column width={2}>
                  <br/>
                  <br/>
                  <Label pointing='left' className='sample-table-label'>Click the cells to copy!</Label>
                </Grid.Column>
              </Grid.Row>
              {
                error ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      error
                      header='Attendance Error'
                      content='Attendances must be between 70 and 100.'
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                dirtyInput ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      warning
                      header='Some changes were made.'
                      content="Please save."
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                success ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      positive
                      header='Attendance successfully saved!'
                      content='Good job!'
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                sectionDetail.status === 'Discarded' ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      warning
                      header={`Your submission was discarded by ${sectionDetail.discardBy}`}
                      content={sectionDetail.discardNotes}
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              <Grid.Row>
                <Grid.Column width={16}>
                  <Tab panes={panes} />
                </Grid.Column>
              </Grid.Row>

            </Grid>
          }

        </Segment>
      </div>
    )
  } else {
    return <Redirect to='/' />
  }

}

export default AttendancesPV;
